import Vue from 'vue'
import Component from 'vue-class-component'
import { Store } from 'vuex'
import RootState from '../../store/state'
import * as ClipboardJS from 'clipboard'
import { SiteUrlModel } from '../../store/manager/state'

@Component({
  props: {
    siteUrlModel: {
      type: Object, /* ArticleData */
      required: true
    }
  }
})
export default class GetSiteUrlModal extends Vue {
  name: 'GetSiteUrlModal'
  $store: Store<RootState>
  copyBtn: NodeListOf<Element>
  clipboard: ClipboardJS
  message: string = ''
  readonly siteUrlModel: SiteUrlModel

  get url(): string {
    if (!this.siteUrlModel) {
      this.message = 'リンクの取得に失敗しました。ダイアログを開き直して下さい。'
      return ''
    }
    return this.siteUrlModel.url
  }

  get canGetSiteUrl(): boolean {
    return this.siteUrlModel.isAccessible
  }

  getSiteUrlTitle(): string {
    return this.canGetSiteUrl ? '' : '公開されていないため見られません。'
  }

  destroy(): void {
    this.clipboard.destroy()
  }

  mounted(): void {
    this.url
    // clipboard 初期化
    this.copyBtn = this.$el.getElementsByClassName('urlCopy')
    this.clipboard = new ClipboardJS(this.copyBtn)
  }

  copyEvent(): void {
    this.clipboard.on('success', (e) => {
      this.message = 'リンクをコピーしました。(' + e.text + ')'
      e.clearSelection()
    })

    this.clipboard.on('error', (e) => {
      this.message = 'リンクのコピーに失敗しました。もう一度コピーして下さい。'
      console.error('error', e)
    })
  }

  submitEvent(): any {
    return this.$emit('submit')
  }

  close(): any {
    return this.$emit('close')
  }
}
